import { css, FlattenSimpleInterpolation } from 'styled-components';
import { spin } from '../animation';

export const spinAnimation = (speed = 1): FlattenSimpleInterpolation => css`
  animation: ${spin} ${speed}s linear infinite;
`;
